import { render, staticRenderFns } from "./TraningVideos.vue?vue&type=template&id=1bb34c07&scoped=true&"
import script from "./TraningVideos.vue?vue&type=script&lang=ts&"
export * from "./TraningVideos.vue?vue&type=script&lang=ts&"
import style0 from "./TraningVideos.vue?vue&type=style&index=0&id=1bb34c07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb34c07",
  null
  
)

export default component.exports